import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {aggiornaStatoKpiApi, getStatoKpiByIdApi} from "./services/StatiServices";
import ModificaStatoKpiView from "./ModificaStatoKpiView";

export default function ModificaStatoKpiController() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getStatiKpi() {
        const response = await getStatoKpiByIdApi(id);
        setLoadingData(false);

        if (formikRef.current) {
            let data = response.data.data;
            formikRef.current.setFieldValue("id_stato_kpi", data.id_stato_kpi)
            formikRef.current.setFieldValue("codice", data.codice)
            formikRef.current.setFieldValue("descrizione", data.descrizione)
            formikRef.current.setFieldValue("canc", data.canc)
            formikRef.current.setFieldValue("colore", data.colore)
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getStatiKpi();
            }
        }

    }, [id]);

    const SignupSchema = Yup.object().shape({
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
    });

    async function aggiornaStatoKpi(values) {
        const response = await aggiornaStatoKpiApi(id, values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const initialValuesForm = {
        id: '',
        codice: '',
        descrizione: '',
        canc: '',
        colore: '{"r":255,"g":255,"b":255,"a":1}'
    };

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    function onChangeColore(color) {
        formikRef.current.setFieldValue("colore", JSON.stringify(color.rgb))
    }

    return (
        <ModificaStatoKpiView
            formikRef={formikRef}
            show={show}
            setShow={setShow}
            SignupSchema={SignupSchema}
            modalMsg={modalMsg}
            translate={translate}
            aggiornaStatoKpi={aggiornaStatoKpi}
            initialValuesForm={initialValuesForm}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            onChangeColore={onChangeColore}
        />
    );
}